import AccountStatistics from "./AccountStatistics"

export default AccountStatistics
